export const LeaderBoardFigureValueType = {
    RankingScoreBVHChallenge: "rankingscorebvhchallenge",
    PerformanceBVHChallenge: "performancebvhchallenge",
    MaxDrawdownBVHChallenge: "maxdrawdownbvhchallenge",
    RiskWeightBVHChallenge: "riskweightbvhchallenge",
    HerfindahlBVHChallenge: "herfindahlindexbvhchallenge",
} as const;
